import { SECTIONS } from "./constants";

// Which fields belong to each section. Used to compute a "answered / total" ratio
// so consultants get a live progress indicator while filling the intake form.
const SECTION_FIELDS = {
  s1: ["org_name", "abn", "contact_name", "contact_phone", "contact_email",
       "discovery_date", "target_registration_date"],
  s2: ["entity_type", "workforce_model", "worker_count", "ahpra_regulated"],
  s3: ["states", "site_types"],
  s4: ["registration_groups"],
  s5: ["rp_regulated", "bsp_develop", "bsp_implement"],
  s6: ["high_intensity"],
  s7: ["cohorts"],
  s8: ["documents_held"],
  s9: ["timeline_driver", "prepared_4_6_weeks", "aqa_budgeted"],
};

function isAnswered(v) {
  if (Array.isArray(v)) return v.length > 0;
  if (typeof v === "number") return v > 0;
  return typeof v === "string" ? v.trim() !== "" : Boolean(v);
}

function sectionRatio(sid, form) {
  const fields = SECTION_FIELDS[sid] || [];
  const answered = fields.filter((k) => isAnswered(form?.[k])).length;
  return { answered, total: fields.length };
}

function pillClass(pct) {
  if (pct >= 100) return "bg-[#1A7F6E] text-white";
  if (pct >= 50) return "bg-amber-100 text-amber-800";
  if (pct > 0) return "bg-slate-200 text-slate-700";
  return "bg-slate-100 text-slate-400";
}

export default function SectionSidebar({ form }) {
  const rows = SECTIONS.map((s) => {
    const { answered, total } = sectionRatio(s.id, form);
    const pct = total ? Math.round((answered / total) * 100) : 0;
    return { ...s, answered, total, pct };
  });
  const totalPct = Math.round(
    (rows.reduce((a, r) => a + r.answered, 0) /
      Math.max(1, rows.reduce((a, r) => a + r.total, 0))) * 100
  );

  return (
    <aside className="hidden lg:block no-print">
      <div className="sticky top-24">
        <div className="flex items-center justify-between mb-3">
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500">Sections</p>
          <span className="text-[11px] font-semibold text-[#1A7F6E]" data-testid="assessment-total-progress">
            {totalPct}%
          </span>
        </div>
        <ul className="space-y-1">
          {rows.map((s) => (
            <li key={s.id}>
              <a
                href={`#${s.id}`}
                className="text-sm text-slate-600 hover:text-[#1A7F6E] flex items-center justify-between gap-2 py-1.5 border-l-2 border-transparent hover:border-[#1A7F6E] pl-3 transition-colors"
                data-testid={`nav-${s.id}`}
              >
                <span className="truncate">{s.title}</span>
                <span
                  className={`shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded ${pillClass(s.pct)}`}
                  data-testid={`progress-${s.id}`}
                  title={`${s.answered} of ${s.total} answered`}
                >
                  {s.answered}/{s.total}
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}
